import { Marker } from '@react-google-maps/api';
import { StopLocation } from '../../store/config/types';
import { customerLabel } from '../../utils/trips.helper';
import { getCustomerDisplayName } from '../../utils/string.helpers';
interface CustomerMarkerProps {
  location: StopLocation;
  color?: string;
  highlight?: boolean;
  customerIndex?: number;
  /* eslint-disable */
  onHover?: (customerId: number, isOver: boolean) => void;
  onClick?: (locationId: number) => void;
  /* eslint-enable */
}
export default function CustomerMarker({
  location,
  color,
  highlight,
  customerIndex,
  onHover,
  onClick,
}: CustomerMarkerProps) {
  const label = location.label ?? customerLabel(location.customer, customerIndex ? customerIndex + 1 : undefined);
  return (
    <>
      <Marker
        position={{ lat: location.latitude, lng: location.longitude }}
        icon={{
          path: 'M -10,0 a 10,10 0 1,0 20,0 a 10,10 0 1,0 -20,0',
          fillColor: 'black',
          strokeColor: 'black',
          strokeWeight: 15,
          fillOpacity: 1,
        }}
      />
      <Marker
        position={{ lat: location.latitude, lng: location.longitude }}
        onMouseOver={() => {
          onHover && onHover(location.customer?.customerId ?? 0, true);
        }}
        onMouseOut={() => {
          onHover && onHover(location.customer?.customerId ?? 0, false);
        }}
        onClick={() => {
          onClick && onClick(location.locationId ?? 0);
        }}
        icon={
          highlight
            ? {
                path: 'M -10,0 a 10,10 0 1,0 20,0 a 10,10 0 1,0 -20,0',
                fillColor: 'black',
                strokeColor: 'black',
                strokeWeight: 20,
                fillOpacity: 1,
              }
            : {
                path: 'M -10,0 a 10,10 0 1,0 20,0 a 10,10 0 1,0 -20,0',
                fillColor: color ?? 'red',
                strokeColor: color ?? 'red',
                strokeWeight: 8,
                fillOpacity: 1,
              }
        }
        label={{
          text: label,
          fontSize: '12px',
          color: highlight ? 'white' : 'black',
        }}
        title={location.customer ? getCustomerDisplayName(location.customer) : undefined}
      />
    </>
  );
}
